import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";

const useStyles = makeStyles((theme) => ({
  accordionRoot: {
    "&::before": {
      display: "none",
    },
    border: "none",
    boxShadow: theme.shadows[0],
  },
  accordionSummaryRoot: {
    "&.Mui-expanded": {
      display: "none",
      visibility: "hidden",
    },
    padding: 0,
    minHeight: "auto",
  },
  accordionSummaryContent: {
    margin: 0,
  },
}));

function Expandatble({ children }) {
  const classes = useStyles();
  return (
    <Accordion classes={{ root: classes.accordionRoot }} square>
      <AccordionSummary
        classes={{
          root: classes.accordionSummaryRoot,
          content: classes.accordionSummaryContent,
        }}
      >
        Click to view hidden accounts
      </AccordionSummary>
      {children}
    </Accordion>
  );
}

export default Expandatble;
